import React from 'react';

interface MaintenanceRedirectWrapperProps {
  children: React.ReactNode;
}

const MaintenanceRedirectWrapper: React.FC<MaintenanceRedirectWrapperProps> = ({ children }) => {
  return <>{children}</>;
};

export default MaintenanceRedirectWrapper;
